import { render } from "./ShortPopUpNotification.vue?vue&type=template&id=5de9479c&scoped=true"
import script from "./ShortPopUpNotification.vue?vue&type=script&lang=js"
export * from "./ShortPopUpNotification.vue?vue&type=script&lang=js"

import "./ShortPopUpNotification.vue?vue&type=style&index=0&id=5de9479c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5de9479c"

export default script